// ABOUTME: FlipYourCoin button component for emotional regulation recovery recognition (Issue #382, #633)
// ABOUTME: Displays reset icon with spin animation and records BehaviorType.FlipYourCoin with no ladder movement

import React, { useState } from 'react';
import { Box, useMediaQuery, useTheme } from '@mui/material';
import { styled } from '@mui/material/styles';
import { PikoIcon } from '../utils/behaviorUtils';
import { BehaviorType } from '../types/api';
import { StyledActionButton, mobileIconOnlySx } from './shared/StyledActionButton';
import naluV1Theme from '../theme/theme.nalu-v1';

const SpinAnimationContainer = styled(Box)(() => ({
  display: 'inline-flex',
  alignItems: 'center',
  justifyContent: 'center',
  '&.spin-animation': {
    animation: 'spin 0.6s ease-in-out',
  },
  '@keyframes spin': {
    '0%': {
      transform: 'rotate(0deg)',
    },
    '100%': {
      transform: 'rotate(360deg)',
    },
  },
}));

interface FlipYourCoinButtonProps {
  child: { childId: number | string; name?: string };
  onBehaviorRecorded?: (behaviorType: BehaviorType) => void;
}

const FlipYourCoinButton: React.FC<FlipYourCoinButtonProps> = ({
  onBehaviorRecorded
}) => {
  const [isAnimating, setIsAnimating] = useState(false);
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));

  const handleFlipYourCoin = () => {
    setIsAnimating(true);

    // Just trigger the callback - let the parent handle the API call
    if (onBehaviorRecorded) {
      onBehaviorRecorded(BehaviorType.FlipYourCoin);
    }

    // Keep animation for visual feedback
    setTimeout(() => setIsAnimating(false), 600);
  };

  return (
    <StyledActionButton
      data-testid="flip-your-coin-button"
      variant="outlined"
      onClick={handleFlipYourCoin}
      startIcon={
        <SpinAnimationContainer
          data-testid="restart-icon"
          className={isAnimating ? 'spin-animation' : ''}
        >
          <PikoIcon data-testid="RestartAltIcon" />
        </SpinAnimationContainer>
      }
      aria-label="Record emotional regulation recovery - Flip Your Coin"
      tabIndex={0}
      sx={isMobile ? mobileIconOnlySx(theme.logoSrc === naluV1Theme.logoSrc) : undefined}
    >
      {isMobile ? null : 'Flip Your Coin'}
    </StyledActionButton>
  );
};

export default FlipYourCoinButton;
